"use strict";
// packages/types/src/smartTable.ts
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMART_TABLE_HEADERS = exports.SmartTableType = void 0;
var SmartTableType;
(function (SmartTableType) {
    SmartTableType["RECORDS_LIST"] = "records_list";
    SmartTableType["APPROVED_SUPPLIERS_LIST"] = "approved_suppliers_list";
    SmartTableType["INCOMING_GOODS_LIST"] = "incoming_goods_list";
    SmartTableType["PROCESS_STEPS_LIST"] = "process_steps_list";
    SmartTableType["CCPS_LIST"] = "ccps_list";
    SmartTableType["HAZARDS_LIST"] = "hazards_list";
})(SmartTableType || (exports.SmartTableType = SmartTableType = {}));
/**
 * Table headers for each smart table type
 * Single source of truth for smart table column headers
 */
exports.SMART_TABLE_HEADERS = (_a = {},
    _a[SmartTableType.RECORDS_LIST] = ['Collection Name', 'Description'],
    _a[SmartTableType.APPROVED_SUPPLIERS_LIST] = ['Name', 'Contact', 'Address', 'Status'],
    _a[SmartTableType.INCOMING_GOODS_LIST] = ['Name', 'Supplier', 'Description', 'Product Code'],
    _a[SmartTableType.PROCESS_STEPS_LIST] = ['Step Number', 'Process', 'Type', 'Controls'],
    _a[SmartTableType.CCPS_LIST] = ['CCP #', 'Name', 'Process Step', 'Critical Limit'],
    _a[SmartTableType.HAZARDS_LIST] = ['Hazard Name', 'Process Step', 'Type', 'Likelihood', 'Severity', 'Consequence', 'CCP'],
    _a);
